/**
 * SessionDateRangesEditor.jsx — Wave 1u3 refactor step 2 (FE).
 *
 * Vague 98.9 — Multi-date ranges editor for sessions non-consécutives.
 * The first period uses the session's startDate/endDate above; this editor
 * manages the additional periods stored in `date_ranges[]`.
 *
 * Purely presentational: receives the array and emits the updated array.
 */
import React from 'react';
import { X } from 'lucide-react';
import { inputCls } from './SessionFormShared';

export default function SessionDateRangesEditor({ dateRanges, onChange }) {
  const ranges = dateRanges || [];

  const updateRange = (idx, key, value) => {
    const next = [...ranges];
    next[idx] = { ...next[idx], [key]: value };
    onChange(next);
  };

  const removeRange = (idx) => onChange(ranges.filter((_, j) => j !== idx));

  const addRange = () => onChange([...ranges, { startDate: '', endDate: '' }]);

  return (
    <div className="rounded-xl border border-[#EFF0F6] bg-[#FAFAFE] p-3" data-testid="session-date-ranges-editor">
      <div className="flex items-center gap-2 mb-2">
        <div className="text-[12px] font-semibold text-[#1A1B2E]">Périodes supplémentaires</div>
        <span className="text-[10.5px] text-[#8E8FA5]">
          Optionnel — pour des sessions non-consécutives (ex : 3 j en mai, 2 j en juin)
        </span>
      </div>
      <div className="space-y-2">
        {ranges.map((dr, idx) => (
          <div key={idx} className="flex items-center gap-2" data-testid={`session-extra-range-${idx}`}>
            <span className="text-[11px] text-[#6B6C85] w-16 shrink-0">Période {idx + 2}</span>
            <input
              type="date"
              value={dr.startDate || ''}
              onChange={(e) => updateRange(idx, 'startDate', e.target.value)}
              className={`${inputCls} flex-1`}
              data-testid={`session-extra-range-${idx}-start`}
            />
            <span className="text-[11px] text-[#6B6C85]">au</span>
            <input
              type="date"
              value={dr.endDate || ''}
              onChange={(e) => updateRange(idx, 'endDate', e.target.value)}
              className={`${inputCls} flex-1`}
              data-testid={`session-extra-range-${idx}-end`}
            />
            <button
              type="button"
              onClick={() => removeRange(idx)}
              className="w-8 h-8 rounded-lg hover:bg-[#FEF2F2] text-[#B91C1C] flex items-center justify-center"
              title="Supprimer cette période"
              data-testid={`session-extra-range-${idx}-delete`}
            >
              <X className="w-3.5 h-3.5" />
            </button>
          </div>
        ))}
        <button
          type="button"
          onClick={addRange}
          className="h-8 px-3 rounded-lg bg-white border border-dashed border-[#4F46E5] text-[#4F46E5] text-[12px] font-semibold hover:bg-[#EEF2FF]"
          data-testid="session-extra-range-add"
        >
          + Ajouter une autre période
        </button>
      </div>
    </div>
  );
}
